import styles from './LeadSpaceShort.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class LeadSpaceShort extends CustomComponent {
    constructor() {
        super();
        this.customStyle = styles;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add('lead-space-short');
        container.innerHTML = `
            <div class="body">
                <div class="link"><slot name="link"></slot></div>
                <div class="content">
                    <div class="heading">
                        <div class="title"><slot name="title"></slot></div>
                        <div class="subheading">
                            <div class="subtitle"><slot name="subtitle"></slot></div>
                            <div class="helper-text"><slot name="helper-text"></slot></div>
                            <div class="socials"><slot name="socials"></slot></div>
                        </div>
                    </div>
                    <div class="cta"><slot name="cta"></slot></div>
                </div>
            </div>
        `;
        this.setHasSlottedToParent(container);
        return container;
    }
}

customElements.define('nxt-lead-space-short', LeadSpaceShort);
